import { App } from 'vue';

import i18n from '@/vueI18n';

import BaseEvaluator from './BaseEvaluator';

export default class RequiredEvaluator extends BaseEvaluator {
  vue: App;

  constructor(fieldName, friendlyFieldName, model, mutator = null, vue: App = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'required_or';
    this.vue = vue;
  }

  validate() {
    const isFirstValid = this.value !== undefined && this.value !== null && this.value !== '';
    const isSecondValid =
      this.model[this.mutator[0]] !== undefined &&
      this.model[this.mutator[0]] !== null &&
      this.model[this.mutator[0]] !== '';
    this.isValid = isFirstValid || isSecondValid;
    return this.isValid;
  }

  getMessage(validatorDictionary) {
    if (this.isValid) {
      return {
        type: 'valid',
        message: '',
      };
    }
    const func = validatorDictionary[this.evaluatorName];
    this.mutator[0] = i18n.global.t(`validatorNames.${this.mutator[0]}`);
    return {
      type: 'error',
      message: func(this.friendlyFieldName, this.mutator),
    };
  }
}
